import { render, staticRenderFns } from "./PictureView.vue?vue&type=template&id=2030cb91&scoped=true"
import script from "./PictureView.vue?vue&type=script&lang=js"
export * from "./PictureView.vue?vue&type=script&lang=js"
import style0 from "./PictureView.vue?vue&type=style&index=0&id=2030cb91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030cb91",
  null
  
)

export default component.exports